import { createAction, props } from '@ngrx/store';

import { ProductV2 } from '../../models/product-v2.model';
import { ProductV2Variation } from '../../models/product-v2.model';
import { Draft } from '../../models/order.model';

import { CartItem } from './cart.state';

export interface CartItemPayload {
  product: ProductV2;
  quantity: number;
  selectedVariation?: ProductV2Variation;

  // quando true, não exibe o toast de sucesso padrão
  suppressSuccessToast?: boolean;
}

export interface RemoveItemPayload {
  itemId: string;
  removedItem?: CartItem;
}

export interface UpdateQuantityPayload {
  itemId: string;
  quantity: number;
}

export interface UpdateProductPayload {
  itemId: string;
  product: ProductV2;
}

export interface UpdateCartItemPayload {
  itemId: string;
  updates: Partial<CartItem>;
}

export interface LoadCartPayload {
  items: any[];
  source: 'localStorage' | 'backend' | 'url';
}

export interface SidebarHeaderPayload {
  icon?: string;
  customIcon?: any;
  title: string;
}

export const addItem = createAction(
  '[Cart] Add Item',
  props<CartItemPayload>()
);

export const removeItem = createAction(
  '[Cart] Remove Item',
  props<RemoveItemPayload>()
);

export const updateQuantity = createAction(
  '[Cart] Update Quantity',
  props<UpdateQuantityPayload>()
);

export const updateProduct = createAction(
  '[Cart] Update Product',
  props<UpdateProductPayload>()
);

export const updateCartItem = createAction(
  '[Cart] Update Cart Item',
  props<UpdateCartItemPayload>()
);

export const clearCart = createAction(
  '[Cart] Clear Cart',
  props<{ clearedItems?: CartItem[]; emitEvent?: boolean }>()
);

export const clearLocalCart = createAction('[Cart] Clear Local Cart');

export const loadCart = createAction('[Cart] Load Cart');

export const loadCartSuccess = createAction(
  '[Cart] Load Cart Success',
  props<LoadCartPayload>()
);

export const loadCartFromDraft = createAction(
  '[Cart] Load Cart From Draft',
  props<{ draft: Draft }>()
);

export const syncCart = createAction('[Cart] Sync Cart');

export const operationSuccess = createAction('[Cart] Operation Success');

export const operationFailure = createAction(
  '[Cart] Operation Failure',
  props<{ error: string; context?: string }>()
);

export const setLoading = createAction(
  '[Cart] Set Loading',
  props<{ loading: boolean }>()
);

export const setUrlCartLoading = createAction(
  '[Cart] Set URL Cart Loading',
  props<{ loading: boolean }>()
);

export const openCartSidebar = createAction('[Cart] Open Sidebar');

export const closeCartSidebar = createAction('[Cart] Close Sidebar');

export const setSidebarHeader = createAction(
  '[Cart] Set Sidebar Header',
  props<SidebarHeaderPayload>()
);